import {
  Grid,
  Box,
  OutlinedInput,
  InputAdornment,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import classNames from "classnames";
import { useEffect } from "react";
import {
  FieldValues,
  UseFormHandleSubmit,
  UseFormRegister,
} from "react-hook-form";
import { stateConfig } from "../../../configs/state";
import { UserData } from "../../../types/user-data";
import { phoneFormat } from "../../../utils/common-function";

import "../../styles.css";
import { useTranslation } from "react-i18next";

interface Props extends UserData {
  updateFields: (fields: Partial<UserData>) => void;
  data: Partial<UserData>;
  errors: any;
  resetField?: any;
  register: UseFormRegister<FieldValues>;
  handleSubmit: UseFormHandleSubmit<FieldValues>;
  setItemList: (fields: any) => void;
}
interface BodilyInjuryProps extends UserData {
  updateFields: (fields: Partial<UserData>) => void;
  data: Partial<UserData>;
  errors: any;
  resetField?: any;
  register: UseFormRegister<FieldValues>;
  handleSubmit: UseFormHandleSubmit<FieldValues>;
  bodilyInjurySubTotal: number;
}
export const BodilyInjury: React.FC<BodilyInjuryProps> = ({
  data,
  updateFields,
  bodilyInjurySubTotal,
  register,
  errors,
}) => {
  const { t } = useTranslation();
  useEffect(() => {
    if (data?.bodily_injury_lost_wages!.length > 11) {
      data.bodily_injury_lost_wages = "";
    }
    if (data?.bodily_injury_medical_expenses!.length > 11) {
      data.bodily_injury_medical_expenses = "";
    }
    if (data?.bodily_injury_other_losses!.length > 11) {
      data.bodily_injury_other_losses = "";
    }
  }, [
    data,
    data?.bodily_injury_lost_wages,
    data?.bodily_injury_medical_expenses,
    data.bodily_injury_other_losses,
  ]);

  return (
    <>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <h2 className="subheader">{t('BodilyInjury')}</h2>
      </Grid>
      <Box sx={{ maxWidth: "21.875rem" }}>
        <div className="formLabel">
          <label htmlFor="lostWages">{t('LostWages')}</label>
        </div>
        <div className="input-icon">
          <input
            className={classNames(
              "adornedInput",
              Number.parseFloat(data?.bodily_injury_lost_wages!) > 10000000 ||
                data.bodily_injury_lost_wages?.toString().split(".")[1]
                  ?.length! > 2
                ? "errorInput"
                : "input"
            )}
            {...register("bodily_injury_lost_wages", {
              required: false,
              pattern: {
                value: /^[0-9]+(\.[0-9]+)?$/,
                message:
                  "Invalid amount entry. Please enter value between 0.00 and 10000000.00",
              },
              onChange: (e) => {
                updateFields({
                  bodily_injury_lost_wages: e.target.value.replaceAll(
                    /[^0-9.]/gi,
                    ""
                  ),
                });
              },
            })}
            id="lostWages"
            value={data.bodily_injury_lost_wages}
            aria-describedby="bodily_injury_lost_wages_error"
          />
          <i>$</i>
        </div>

        {(Number.parseFloat(data.bodily_injury_lost_wages!) > 10000000 ||
          data.bodily_injury_lost_wages?.toString().split(".")[1]?.length! >
            2) && (
          <div className="errorText" id="bodily_injury_lost_wages_error">
            {t('ErrorInvalidAmountEntry')}
          </div>
        )}
      </Box>

      <Box sx={{ maxWidth: "21.875rem" }}>
        <div className="formLabel">
          <label htmlFor="medicalExpenses">{t('MedicalExpenses')}</label>
        </div>
        <div className="input-icon">
          <input
            className={classNames(
              "adornedInput",
              Number.parseFloat(data?.bodily_injury_medical_expenses!) > 10000000 ||
                data.bodily_injury_medical_expenses?.toString().split(".")[1]
                  ?.length! > 2
                ? "errorInput"
                : "input"
            )}
            {...register("bodily_injury_medical_expenses", {
              required: false,
              pattern: {
                value: /^[0-9]+(\.[0-9]+)?$/,
                message:
                  "Invalid amount entry. Please enter value between 0.00 and 10000000.00",
              },
              onChange: (e) => {
                updateFields({
                  bodily_injury_medical_expenses: e.target.value.replaceAll(
                    /[^0-9.]/gi,
                    ""
                  ),
                });
              },
            })}
            id="medicalExpenses"
            value={data.bodily_injury_medical_expenses}
            aria-describedby="bodily_injury_medical_expense_error"
          />
          <i>$</i>
        </div>

        {(Number.parseFloat(data.bodily_injury_medical_expenses!) > 10000000 ||
          data.bodily_injury_medical_expenses?.toString().split(".")[1]
            ?.length! > 2) && (
          <div className="errorText" id="bodily_injury_medical_expense_error">
            {t('ErrorInvalidAmountEntry')}
          </div>
        )}
      </Box>

      <Box sx={{ maxWidth: "21.875rem" }}>
        <div className="formLabel">
          <label htmlFor="otherLosses">{t('OtherLosses')}</label>
        </div>
        <div className="input-icon">
          <input
            className={classNames(
              "adornedInput",
              Number.parseFloat(data?.bodily_injury_other_losses!) > 10000000 ||
                data.bodily_injury_other_losses?.toString().split(".")[1]
                  ?.length! > 2
                ? "errorInput"
                : "input"
            )}
            {...register("bodily_injury_other_losses", {
              required: false,
              pattern: {
                value: /^[0-9]+(\.[0-9]+)?$/,
                message:
                  "Invalid amount entry. Please enter value between 0.00 and 10000000.00",
              },
              onChange: (e) => {
                updateFields({
                  bodily_injury_other_losses: e.target.value.replaceAll(
                    /[^0-9.]/gi,
                    ""
                  ),
                });
              },
            })}
            id="otherLosses"
            value={data.bodily_injury_other_losses}
            aria-describedby="bodily_injury_other_losses_error"
          />
          <i>$</i>
        </div>

        {(Number.parseFloat(data.bodily_injury_other_losses!) > 10000000 ||
          data.bodily_injury_other_losses?.toString().split(".")[1]?.length! >
            2) && (
          <div className="errorText" id="bodily_injury_other_losses_error">
            {t('ErrorInvalidAmountEntry')}
          </div>
        )}
      </Box>

      <div className="formLabel">
        <label htmlFor="other">{t('PleaseDescribeOtherLosses')}</label>
      </div>
      <textarea
        id="other"
        maxLength={250}
        rows={8}
        cols={46}
        value={data.bodily_injury_other_desc}
        {...register("bodily_injury_other_desc")}
        onChange={(e) =>
          updateFields({
            bodily_injury_other_desc: e.target.value
              .trimStart()
              .replaceAll(/[~`!^;|\\":<>?]/gi, ""),
          })
        }
      />
      <div  aria-live="polite">
        {t('YouHave')} <strong>{250 - data.bodily_injury_other_desc!.length}</strong> {t('CharactersRemaining')}
      </div>

      <Box sx={{ maxWidth: "21.875rem" }}>
        <div className="formLabel">
          <label htmlFor="subTotalebodilyinjury">{t('Subtotal')}</label>
        </div>
        <OutlinedInput
          disabled={true}
          fullWidth
          type="number"
          sx={{
            height: "44px",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#4f4f4f",
            },
          }}
          inputProps={{ min: "0", step: ".01" }}
          id="subTotalebodilyinjury"
          size="small"
          value={bodilyInjurySubTotal.toFixed(2)}
          startAdornment={<InputAdornment position="start">$</InputAdornment>}
        />
      </Box>
      <br />
      <br />
    </>
  );
};

export const IncidentInvolves: React.FC<Props> = ({
  errors,
  register,
  resetField,
  data,
  updateFields,
  setItemList,
}) => {
  const { t } = useTranslation();
  useEffect(() => {
    if (data.incident_involves === "PropertyDamage") {
      data.bodily_injury_lost_wages = "";
      data.bodily_injury_medical_expenses = "";
      data.bodily_injury_other_losses = "";
      data.bodily_injury_other_desc = "";
    }
    if (data.incident_involves === "PropertyDamage") {
      data.bodily_injury_lost_wages = "";
      data.bodily_injury_medical_expenses = "";
      data.bodily_injury_other_losses = "";
      data.bodily_injury_other_desc = "";
    }
  }, [data.incident_involves]);

  function resetFields() {
    setItemList([]);
    resetField("bodily_injury_medical_expenses");
    resetField("bodily_injury_lost_wages");
    resetField("bodily_injury_other_losses");
    resetField("bodily_injury_other_desc");
    data.bodily_injury_lost_wages = "";
    data.bodily_injury_medical_expenses = "";
    data.bodily_injury_other_losses = "";
    data.bodily_injury_other_desc = "";
  }
  return (
    <>
      <div className="formLabel">
        <label htmlFor="incLabel" id="incidentInvolves">*{t('IncidentInvolves')}</label>
      </div>
      <RadioGroup
        style={{ marginTop: "5px", marginBottom: "10px" }}
        id="incLabel"
        role="radiogroup"
        aria-labelledby="incidentInvolves"
        aria-describedby="incidentInvolves_error"
        onChange={() => {
          resetFields();
        }}
      >
        <FormControlLabel
          sx={{ height: "28px" }}
          id="incidentInvolves_error"
          {...register("incident_involves", {
            required: true,
            onChange: (e: any) => {
              resetFields();
              updateFields({ incident_involves: e.target.value });
            },
            validate: (value: any) =>
              value === "BodilyInjury" ||
              value === "PropertyDamage" ||
              value === "Both",
          })}
          checked={data.incident_involves === "BodilyInjury"}
          value="BodilyInjury"
          control={
            <Radio sx={errors.incident_involves && { color: "#e2231a" }} />
          }
          label={t('BodilyInjury')}
        />
        <FormControlLabel
          {...register("incident_involves", {
            required: true,
            onChange: (e: any) => {
              resetFields();
              updateFields({ incident_involves: e.target.value });
            },
            validate: (value: any) =>
              value === "BodilyInjury" ||
              value === "PropertyDamage" ||
              value === "Both",
          })}
          checked={data.incident_involves === "PropertyDamage"}
          value="PropertyDamage"
          control={
            <Radio sx={errors.incident_involves && { color: "#e2231a" }} />
          }
          label={t('PropertyDamageFoodSpoilageLabel')}
          id="incidentInvolves_error"
        />
        <FormControlLabel
          sx={{ height: "28px" }}
          id="incidentInvolves_error"
          {...register("incident_involves", {
            required: true,
            onChange: (e: any) => {
              resetFields();
              updateFields({ incident_involves: e.target.value });
            },
            validate: (value: any) =>
              value === "BodilyInjury" ||
              value === "PropertyDamage" ||
              value === "Both",
          })}
          checked={data.incident_involves === "Both"}
          value="Both"
          control={
            <Radio sx={errors.incident_involves && { color: "#e2231a" }} />
          }
          label={t('Both')}
        />
        {errors.incident_involves && (
          <div className="errorText" id="incidentInvolves_error">
            {t('ErrorPleaseChooseOptionIncidentInvolves')}
          </div>
        )}
      </RadioGroup>
    </>
  );
};

export const VehicleOwnerInfo: React.FC<Props> = ({
  data,
  updateFields,
  errors,
  register,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <br />
      <br />
      <h2 className="subheader">{t('VehicleOwnerInformation')}</h2>

      <div className="formLabel">
        <label htmlFor="vehicleOwnerFirstName">
          *{t('VehicleOwnerFirstName')}
        </label>
      </div>

      <input
        id="vehicleOwnerFirstName"
        className={classNames(
          errors.vehicle_owner_first_name ? "errorInput" : "input"
        )}
        {...register("vehicle_owner_first_name", {
          required: true,
          onChange: (e) =>
            updateFields({
              vehicle_owner_first_name: e.target.value
                .trimStart()
                .replaceAll(/[-~`!^;|\\":<>?()@$*{}+=]/gi, ""),
            }),
        })}
        value={data.vehicle_owner_first_name}
        maxLength={50}
        aria-describedby="vehicleOwnerFirstName_error"
      />
      {errors.vehicle_owner_first_name && (
        <div className="errorText" id="vehicleOwnerFirstName_error">
          {t('ErrorVehicleOwnerFirstNameRequired')}
        </div>
      )}
      <div className="formLabel">
        <label htmlFor="vehicleOwnerLastName">*{t('VehicleOwnerLastName')}</label>
      </div>

      <input
        id="vehicleOwnerLastName"
        className={classNames(
          errors.vehicle_owner_last_name ? "errorInput" : "input"
        )}
        {...register("vehicle_owner_last_name", {
          required: true,
          onChange: (e) =>
            updateFields({
              vehicle_owner_last_name: e.target.value
                .trimStart()
                .replaceAll(/[-~`!^;|\\":<>?()@$*{}+=]/gi, ""),
            }),
        })}
        value={data.vehicle_owner_last_name}
        maxLength={50}
        aria-describedby="vehicleOwnerLastName_error"
      />
      {errors.vehicle_owner_last_name && (
        <div className="errorText" id="vehicleOwnerLastName_error">
          {t('ErrorVehicleOwnerLastNameRequired')}
        </div>
      )}
      <div className="formLabel">
        <label htmlFor="vehicleOwnerAddressLine1">*{t('Address')}</label>
      </div>

      <input
        id="vehicleOwnerAddressLine1"
        className={classNames(
          errors.vehicle_owner_address_line1 ? "errorInput" : "input"
        )}
        {...register("vehicle_owner_address_line1", {
          required: true,
          onChange: (e) =>
            updateFields({
              vehicle_owner_address_line1: e.target.value
                .trimStart()
                .replaceAll(/[-~`!^;|\\":<>?()@$*{}+=]/gi, ""),
            }),
        })}
        value={data.vehicle_owner_address_line1}
        maxLength={100}
        aria-describedby="vehicleOwnerAddressLine1_error"
      />
      {errors.vehicle_owner_address_line1 && (
        <div className="errorText" id="vehicleOwnerAddressLine1_error">
          {t('ErrorVehicleOwnerAddressRequired')}
        </div>
      )}
      <div className="formLabel">
        <label htmlFor="vehicleOwnerAddressLine2">{t('AptSuite')}:</label>
      </div>
      <input
        id="vehicleOwnerAddressLine2"
        className="input"
        value={data.vehicle_owner_address_line2}
        {...register("vehicle_owner_address_line2")}
        onChange={(e) =>
          updateFields({
            vehicle_owner_address_line2: e.target.value
              .trimStart()
              .replaceAll(/[-~`!^;|\\":<>?()@$*{}+=]/gi, ""),
          })
        }
      />
      <div className="formLabel">
        <label htmlFor="vehicleOwnerCity">*{t('City')}</label>
      </div>
      <input
        id="vehicleOwnerCity"
        className={classNames(
          errors.vehicle_owner_city ? "errorInput" : "input"
        )}
        {...register("vehicle_owner_city", {
          required: true,
          onChange: (e) =>
            updateFields({
              vehicle_owner_city: e.target.value
                .trimStart()
                .replaceAll(/[-~`!^;|\\":<>?()@$*{}+=]/gi, ""),
            }),
        })}
        value={data.vehicle_owner_city}
        maxLength={50}
        aria-describedby="vehicleOwnerCity_error"
      />
      {errors.vehicle_owner_city && (
        <div className="errorText" id="vehicleOwnerCity_error">
       {t('ErrorVehicleOwnerCityRequired')}   
        </div>
      )}
      <div className="formLabel">
        <label htmlFor="ownerState">*{t('State')}</label>
      </div>
      <select
        className="inputSmallState"
        id="ownerState"
        aria-describedby="ownerState_error"
        {...register("vehicle_owner_state", {
          required: true,
          onChange: (e) =>
            updateFields({ vehicle_owner_state: e.target.value }),
        })}
        value={data.vehicle_owner_state}
      >
        <option value="">{t('Select')}</option>
        {stateConfig.map((state, index) => (
          <option key={index} value={state.key}>
            {state.key}
          </option>
        ))}
      </select>

      {errors.vehicle_owner_state && (
        <div className="errorText" id="ownerState_error">
          {t('ErrorVehicleOwnerStateRequired')}
        </div>
      )}
      <div className="formLabel">
        <label htmlFor="vehicleOwnerZip">{t('ZIPCode')}</label>
      </div>
      <input
        id="vehicleOwnerZip"
        className={classNames(
          data.vehicle_owner_zip!.length > 0 &&
            data.vehicle_owner_zip!.length !== 5
            ? "errorInput"
            : "input"
        )}
        {...register("vehicle_owner_zip", {
          pattern: {
            value: /\d{5}/,
            message: "Error: Please enter a valid ZIP code",
          },
          onChange: (e) =>
            updateFields({
              vehicle_owner_zip: e.target.value.trim().replaceAll(/[^0-9 ]/gi, ""),
            }),
        })}
        value={data.vehicle_owner_zip}
        maxLength={5}
        aria-describedby="vehicle_owner_zip_error"
      />
      {data.vehicle_owner_zip!.length > 0 &&
      data.vehicle_owner_zip!.length !== 5 ? (
        <div className="errorText" id="vehicle_owner_zip_error">
          {t('ErrorValidZipCodeNumber')}
        </div>
      ) : null}
      <div className="formLabel">
        <label htmlFor="PrimaryPhone">*{t('PrimaryPhone')}</label>
      </div>
      <input
        id="PrimaryPhone"
        maxLength={14}
        value={phoneFormat(data.vehicle_owner_phone)}
        className={classNames(
          errors.vehicle_owner_phone ? "errorInput" : "input"
        )}
        {...register("vehicle_owner_phone", {
          required: true,
          pattern: {
            value: /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/,
            message: "Error: Please enter a valid phone number",
          },
          onChange: (e) => {
            updateFields({ vehicle_owner_phone: e.target.value });
          },
        })}
        aria-describedby="PrimaryPhone_error"
      />
      {errors.vehicle_owner_phone &&
        data.vehicle_owner_phone!.length !== 14 && (
          <div className="errorText" id="PrimaryPhone_error">
            {t('ErrorVehicleOwnerPhoneRequired')}
          </div>
        )}
      <br />
      <br />
    </>
  );
};

export const VehicleInfo: React.FC<Props> = ({
  data,
  updateFields,
  errors,
  register,
  resetField,
}) => {
  const { t } = useTranslation();
  useEffect(() => {
    if (data?.estimated_damage!.length > 11) {
      data.estimated_damage = "";
    }
  }, [data, data?.estimated_damage]);

  function resetFields() {
    data.vehicle_owner_zip = "";
    resetField("vehicle_owner_first_name");
    resetField("vehicle_owner_last_name");
    resetField("vehicle_owner_address_line1");
    resetField("vehicle_owner_address_line2");
    resetField("vehicle_owner_city");
    resetField("vehicle_owner_state");
    resetField("vehicle_owner_phone");
    resetField("vehicle_owner_zip");
  }
  return (
    <>
      <h2 className="subheader">{t('VehicleInfo')}</h2>

      <div className="formLabel">
        <label htmlFor="CarMake">*{t('CarMake')}</label>
      </div>
      <input
        id="CarMake"
        className={classNames(errors.vehicle_make ? "errorInput" : "input")}
        {...register("vehicle_make", {
          required: true,
          onChange: (e) => {
            updateFields({
              vehicle_make: e.target.value
                .trimStart()
                .replaceAll(/[-~`!^;|\\":<>?()@$*{}+=]/gi, ""),
            });
          },
        })}
        value={data.vehicle_make}
        aria-describedby="CarMake_error"
      />
      {errors.vehicle_make && (
        <div className="errorText" id="CarMake_error">
          {t('ErrorCarMakeRequired')}
        </div>
      )}
      <div className="formLabel">
        <label htmlFor="CarModel">*{t('CarModel')}</label>
      </div>
      <input
        id="CarModel"
        className={classNames(errors.vehicle_model ? "errorInput" : "input")}
        {...register("vehicle_model", {
          required: true,
          onChange: (e) =>
            updateFields({
              vehicle_model: e.target.value
                .trimStart()
                .replaceAll(/[-~`!^;|\\":<>?()@$*{}+=]/gi, ""),
            }),
        })}
        value={data.vehicle_model}
        maxLength={50}
        aria-describedby="CarModel_error"
      />
      {errors.vehicle_model && (
        <div className="errorText" id="CarModel_error">
          {t('ErrorCarModelRequired')}
        </div>
      )}

      <div className="formLabel">
        <label htmlFor="CarYear">*{t('CarYear')}</label>
      </div>
      <input
        id="CarYear"
        className={classNames(errors.vehicle_year ? "errorInput" : "input")}
        {...register("vehicle_year", {
          required: true,
          onChange: (e) => updateFields({ vehicle_year: e.target.value }),
        })}
        type="number"
        onInput={(e) => {
          (e.target as HTMLInputElement).value = Math.max(
            0,
            Number.parseInt((e.target as HTMLInputElement).value)
          )
            .toString()
            .slice(0, 4);
        }}
        value={data.vehicle_year}
        maxLength={4}
        aria-describedby="CarYear_error"
      />
      {errors.vehicle_year && (
        <div className="errorText" id="CarYear_error">
          {t('ErrorCarYearRequired')}
        </div>
      )}

      <Box sx={{ maxWidth: "21.875rem" }}>
        <div className="formLabel">
          <label htmlFor="EstimatedDamages">*{t('EstimatedDamages')}</label>
        </div>
        <div className="input-icon">
          <input
            className={classNames(
              "adornedInput",
              Number.parseFloat(data?.estimated_damage!) > 10000000 ||
                data.estimated_damage?.toString().split(".")[1]?.length! > 2 ||
                (errors.estimated_damage && !data.estimated_damage)
                ? "errorInput"
                : "input"
            )}
            {...register("estimated_damage", {
              required: true,
              pattern: {
                value: /^[0-9]+(\.[0-9]+)?$/,
                message:
                  "Invalid amount entry. Please enter value between 0.00 and 10000000.00",
              },
              onChange: (e) => {
                updateFields({
                  estimated_damage: e.target.value.replaceAll(/[^0-9.]/gi, ""),
                });
              },
            })}
            id="EstimatedDamages"
            value={data.estimated_damage}
            aria-describedby="EstimatedDamages_error"
          />
          <i>$</i>
        </div>
        {errors.estimated_damage && !data.estimated_damage && (
          <div className="errorText" id="EstimatedDamages_error">
            {t('ErrorEstimatedDamagesRequired')}
          </div>
        )}

        {(Number.parseFloat(data?.estimated_damage!) > 10000000 ||
          data.estimated_damage?.toString().split(".")[1]?.length! > 2) && (
          <div className="errorText" id="EstimatedDamages_error">
            {t('ErrorInvalidAmountEntry')}
          </div>
        )}
      </Box>

      <div className="formLabel">
        <label htmlFor="vehicleLicensePlate">*{t('LicensePlateNumber')}</label>
      </div>

      <input
        id="vehicleLicensePlate"
        className={classNames(
          errors.vehicle_license_plate ? "errorInput" : "input"
        )}
        {...register("vehicle_license_plate", {
          required: true,
          onChange: (e) =>
            updateFields({
              vehicle_license_plate: e.target.value
                .trimStart()
                .replaceAll(/[-~`!^;|\\":<>?()@$*{}+=]/gi, ""),
            }),
        })}
        value={data.vehicle_license_plate}
        maxLength={10}
        aria-describedby="vehicleLicensePlate_error"
      />
      {errors.vehicle_license_plate && (
        <div className="errorText" id="vehicleLicensePlate_error">
          {t('ErrorLicensePlateNumberRequired')}
        </div>
      )}

      <div className="formLabel">
        <label htmlFor="StateRegistered">{t('StateRegistered')} </label>
      </div>
      <select
        className="inputSmallState"
        id="StateRegistered"
        {...register("vehicle_state_registered", {
          required: true,
          onChange: (e) =>
            updateFields({ vehicle_state_registered: e.target.value }),
        })}
        defaultValue={data.vehicle_state_registered}
        value={data.vehicle_state_registered}
      >
        {stateConfig.map((state, index) => (
          <option key={index} value={state.key}>
            {" "}
            {state.key}
          </option>
        ))}
      </select>

      <div className="formLabel">
        <label id="claimantownerofvehicle" htmlFor="claimantLabel">
          *{t('IsClaimantOwnerOfVehicle')}
        </label>
      </div>
      <RadioGroup
        role="radiogroup"
        id="claimantLabel"
        aria-labelledby="claimantownerofvehicle"
        aria-describedby="claimantownerofvehicle_error"
        style={{ marginTop: "5px", marginBottom: "10px" }}
        value={data.claimant_owner_of_vehicle}
      >
        <FormControlLabel
          sx={{ height: "28px" }}
          value="Yes"
          control={<Radio />}
          {...register("claimant_owner_of_vehicle", {
            required: true,
            onChange: (e) => {
              resetFields();
              updateFields({ claimant_owner_of_vehicle: e.target.value });
            },
            validate: (value) => value === "No" || value === "Yes",
          })}
          label={t('Yes')}
          id="claimantownerofvehicle_error"
        />
        <FormControlLabel
          {...register("claimant_owner_of_vehicle", {
            required: true,
            onChange: (e) => {
              resetFields();
              updateFields({ claimant_owner_of_vehicle: e.target.value });
            },
            validate: (value) => value === "No" || value === "Yes",
          })}
          value="No"
          control={<Radio />}
          label={t('No')}
          id="claimantownerofvehicle_error"
        />
      </RadioGroup>
      {errors.claimant_owner_of_vehicle && (
        <div className="errorText" id="claimantownerofvehicle_error">
          {t('ErrorClaimantOwnerOfVehicle')}
        </div>
      )}
    </>
  );
};

export const MotorVehicleIncident: React.FC<Props> = ({
  data,
  updateFields,
  errors,
  resetField,
  register,
}) => {
  const { t } = useTranslation();
  function resetFields() {
    resetField("vehicle_make");
    resetField("vehicle_model");
    resetField("vehicle_year");
    resetField("estimated_damage");
    resetField("vehicle_license_plate");
    resetField("vehicle_state_registered");
    data.vehicle_license_plate = "";
    data.vehicle_owner_first_name = "";
    data.vehicle_owner_last_name = "";
    data.vehicle_owner_address_line1 = "";
    data.vehicle_owner_address_line2 = "";
    data.vehicle_owner_city = "";
    data.vehicle_owner_state = "";
    data.vehicle_owner_phone = "";
    data.vehicle_owner_zip = "";
    data.claimant_owner_of_vehicle = "Yes";
    resetField("vehicle_owner_first_name");
    resetField("vehicle_owner_last_name");
    resetField("vehicle_owner_address_line1");
    resetField("vehicle_owner_address_line2");
    resetField("vehicle_owner_city");
    resetField("vehicle_owner_state");
    resetField("vehicle_owner_phone");
  }
  return (
    <>
      <div className="formLabel">
        <label id="motorvehicleincident" htmlFor="motorvehicleincLabel">
          *{t('IsThisMotorVehicleIncident')}
        </label>
      </div>
      <RadioGroup
        style={{ marginTop: "5px", marginBottom: "10px" }}
        id="motorvehicleincLabel"
        role="radiogroup"
        aria-labelledby="motorvehicleincident"
        aria-describedby="motorvehicleincident_error"
      >
        <FormControlLabel
          sx={{ height: "28px" }}
          {...register("motor_vehicle_accident", {
            required: true,
            onChange: (e) => {
              resetFields();
              updateFields({ motor_vehicle_accident: e.target.value });
            },
            validate: (value) => value === "No" || value === "Yes",
          })}
          value="Yes"
          checked={data.motor_vehicle_accident === "Yes"}
          control={
            <Radio sx={errors.motor_vehicle_accident && { color: "#e2231a" }} />
          }
          label={t('Yes')}
          id="motorvehicleincident_error"
        />
        <FormControlLabel
          {...register("motor_vehicle_accident", {
            required: true,
            onChange: (e) => {
              resetFields();
              updateFields({ motor_vehicle_accident: e.target.value });
            },
            validate: (value) => value === "No" || value === "Yes",
          })}
          value="No"
          checked={data.motor_vehicle_accident === "No"}
          control={
            <Radio sx={errors.motor_vehicle_accident && { color: "#e2231a" }} />
          }
          label={t('No')}
          id="motorvehicleincident_error"
        />
      </RadioGroup>
      {errors.motor_vehicle_accident && (
        <div className="errorText" id="motorvehicleincident_error">
          {t('ErrorMotorVehicleIncident')}
        </div>
      )}
    </>
  );
};

export const WereYouInjured: React.FC<BodilyInjuryProps> = ({
  data,
  updateFields,
  bodilyInjurySubTotal,
  errors,
  resetField,
  register,
}) => {
  const { t } = useTranslation();
  useEffect(() => {
    if (data.were_you_injured === "No") {
      data.bodily_injury_lost_wages = "";
      data.bodily_injury_medical_expenses = "";
      data.bodily_injury_other_losses = "";
      data.bodily_injury_other_losses = "";
      data.bodily_injury_other_desc = "";
    }
  }, [data.were_you_injured]);
  function resetFields() {
    resetField("bodily_injury_medical_expenses");
    resetField("bodily_injury_lost_wages");
    resetField("bodily_injury_other_losses");
    resetField("bodily_injury_other_desc");
  }
  return (
    <>
      <div className="formLabel">
        <label id="Wereyouinjured" htmlFor="injuredLabel">*{t('WereYouInjured')}</label>
      </div>
      <RadioGroup
        role="radiogroup"
        id="injuredLabel"
        aria-labelledby="Wereyouinjured"
        style={{ marginTop: "5px", marginBottom: "10px" }}
      >
        <FormControlLabel
          sx={{ height: "28px" }}
          {...register("were_you_injured", {
            required: true,
            onChange: (e) => {
              resetFields();
              updateFields({ were_you_injured: e.target.value });
            },
            validate: (value) => value === "No" || value === "Yes",
          })}
          value="Yes"
          checked={data.were_you_injured === "Yes"}
          control={
            <Radio sx={errors.were_you_injured && { color: "#e2231a" }} />
          }
          label={t('Yes')}
          id="motorvehicleincident"
        />
        <FormControlLabel
          {...register("were_you_injured", {
            required: true,
            onChange: (e) => {
              resetFields();
              updateFields({ were_you_injured: e.target.value });
            },
            validate: (value) => value === "No" || value === "Yes",
          })}
          value="No"
          checked={data.were_you_injured === "No"}
          control={
            <Radio sx={errors.were_you_injured && { color: "#e2231a" }} />
          }
          label={t('No')}
          id="motorvehicleincident"
        />
      </RadioGroup>
    </>
  );
};

export const ClaimForYourBusiness: React.FC<Props> = ({
  data,
  updateFields,
  errors,
  register,
  resetField,
  setItemList,
}) => {
  const { t } = useTranslation();
  const resetTable = () => {
    setItemList([]);
  };

  function resetFields() {
    data.estimated_revenue_losses = "";
    data.wages_paid_to_employee = "";
    data.lost_inventory = "";
    resetField("estimated_revenue_losses");
    resetField("wages_paid_to_employee");
    resetField("lost_inventory");
  }
  return (
    <>
      <br />
      <div className="formLabel">
        <label id="claimforyourbusiness" htmlFor="claimForBusLabel">
          *{t('IsThisClaimForBusiness')}
        </label>
      </div>
      <RadioGroup
        style={{ marginTop: "5px", marginBottom: "10px" }}
        id="claimForBusLabel"
        role="radiogroup"
        aria-labelledby="claimforyourbusiness"
        aria-describedby="claimforyourbusiness_error"
      >
        <FormControlLabel
          sx={{ height: "28px", fontSize: "16" }}
          {...register("claim_for_business", {
            required: true,
            onChange: (e) => {
              resetFields();
              updateFields({ claim_for_business: e.target.value });
            },
            validate: (value) => value === "No" || value === "Yes",
          })}
          value="Yes"
          checked={data.claim_for_business === "Yes"}
          control={
            <Radio sx={errors.claim_for_business && { color: "#e2231a" }} />
          }
          label={<span style={{ fontSize: "16" }}>{t('Yes')}</span>}
          id="claimforyourbusiness_error"
        />
        <FormControlLabel
          {...register("claim_for_business", {
            required: true,
            onChange: (e) => {
              resetFields();
              updateFields({ claim_for_business: e.target.value });

              resetTable();
            },
            validate: (value) => value === "No" || value === "Yes",
          })}
          value="No"
          checked={data.claim_for_business === "No"}
          control={
            <Radio sx={errors.claim_for_business && { color: "#e2231a" }} />
          }
          label={t('No')}
          id="claimforyourbusiness_error"
        />
        {errors.claim_for_business && (
          <div className="errorText" id="claimforyourbusiness_error">
            {t('ErrorClaimForBusiness')}
          </div>
        )}
      </RadioGroup>
    </>
  );
};

export const ClaimForYourBusinessFields: React.FC<Props> = ({
  data,
  updateFields,
  errors,
  register,
}) => {
  const { t } = useTranslation();
  useEffect(() => {
    if (data?.estimated_revenue_losses!.length > 11) {
      data.estimated_revenue_losses = "";
    }
    if (data?.wages_paid_to_employee!.length > 11) {
      data.wages_paid_to_employee = "";
    }
    if (data?.lost_inventory!.length > 11) {
      data.lost_inventory = "";
    }
  }, [
    data,
    data?.estimated_revenue_losses,
    data?.wages_paid_to_employee,
    data.lost_inventory,
  ]);

  return (
    <>
      <div className="formLabel">
        <label htmlFor="BusinessName">*{t('BusinessName')}</label>
      </div>
      <input
        id="BusinessName"
        className={classNames(errors.business_name ? "errorInput" : "input")}
        {...register("business_name", {
          required: true,
          onChange: (e) =>
            updateFields({
              business_name: e.target.value
                .trimStart()
                .replaceAll(/[-~`!^;|\\":<>?()@$*{}+=]/gi, ""),
            }),
        })}
        value={data.business_name}
        aria-describedby="BusinessName_error"
      />
      {errors.business_name && (
        <div className="errorText" id="BusinessName_error">
          {t('ErrorBusinessNameRequired')}
        </div>
      )}
      <Box sx={{ maxWidth: "21.875rem" }}>
        <div className="formLabel">
          <label htmlFor="EstimatedRevenueLoss">{t('EstimatedRevenueLoss')}</label>
        </div>
        <div className="input-icon">
          <input
            className={classNames(
              "adornedInput",
              Number.parseFloat(data?.estimated_revenue_losses!) > 10000000 ||
                data.estimated_revenue_losses?.toString().split(".")[1]
                  ?.length! > 2
                ? "errorInput"
                : "input"
            )}
            {...register("estimated_revenue_losses", {
              required: false,
              pattern: {
                value: /^[0-9]+(\.[0-9]+)?$/,
                message:
                  "Invalid amount entry. Please enter value between 0.00 and 10000000.00",
              },
              onChange: (e) => {
                updateFields({
                  estimated_revenue_losses: e.target.value.replaceAll(
                    /[^0-9.]/gi,
                    ""
                  ),
                });
              },
            })}
            id="EstimatedRevenueLoss"
            value={data.estimated_revenue_losses}
            aria-describedby="estimated_revenue_losses_error"
          />
          <i>$</i>
        </div>
        {(Number.parseFloat(data?.estimated_revenue_losses!) > 10000000 ||
          data.estimated_revenue_losses?.toString().split(".")[1]?.length! >
            2) && (
          <div className="errorText" id="estimated_revenue_losses_error">
            {t('ErrorInvalidAmountEntry')}
          </div>
        )}
      </Box>
      <Box sx={{ maxWidth: "21.875rem" }}>
        <div className="formLabel">
          <label htmlFor="WagesPaidtoHourlyEmployees">
            {t('WagesPaidToHourlyEmployees')}
          </label>
        </div>
        <div className="input-icon">
          <input
            className={classNames(
              "adornedInput",
              Number.parseFloat(data?.wages_paid_to_employee!) > 10000000 ||
                data.wages_paid_to_employee?.toString().split(".")[1]?.length! >
                  2
                ? "errorInput"
                : "input"
            )}
            id="WagesPaidtoHourlyEmployees"
            value={data.wages_paid_to_employee}
            {...register("wages_paid_to_employee", {
              required: false,
              pattern: {
                value: /^[0-9]+(\.[0-9]+)?$/,
                message:
                  "Invalid amount entry. Please enter value between 0.00 and 10000000.00",
              },
              onChange: (e) =>
                updateFields({
                  wages_paid_to_employee: e.target.value.replaceAll(
                    /[^0-9.]/gi,
                    ""
                  ),
                }),
            })}
            aria-describedby="wages_paid_to_employee_error"
          />
          <i>$</i>
        </div>
        {(Number.parseFloat(data.wages_paid_to_employee!) > 10000000 ||
          data.wages_paid_to_employee?.toString().split(".")[1]?.length! >
            2) && (
          <div className="errorText" id="wages_paid_to_employee_error">
            {t('ErrorInvalidAmountEntry')}
          </div>
        )}
      </Box>
      <Box sx={{ maxWidth: "21.875rem" }}>
        <div className="formLabel">
          <label htmlFor="LostInventory">{t('LostInventory')}</label>
        </div>
        <div className="input-icon">
          <input
            className={classNames(
              "adornedInput",
              Number.parseFloat(data?.lost_inventory!) > 10000000 ||
                data.lost_inventory?.toString().split(".")[1]?.length! > 2
                ? "errorInput"
                : "input"
            )}
            {...register("lost_inventory", {
              required: false,
              pattern: {
                value: /^[0-9]+(\.[0-9]+)?$/,
                message:
                  "Invalid amount entry. Please enter value between 0.00 and 10000000.00",
              },
              onChange: (e) =>
                updateFields({
                  lost_inventory: e.target.value.replaceAll(/[^0-9.]/gi, ""),
                }),
            })}
            aria-describedby="lost_inventory"
            id="LostInventory"
            value={data.lost_inventory}
          />
          <i>$</i>
        </div>
        {(Number.parseFloat(data.lost_inventory!) > 10000000 ||
          data.lost_inventory?.toString().split(".")[1]?.length! > 2) && (
          <div className="errorText" id="lost_inventory">
            {t('ErrorInvalidAmountEntry')}
          </div>
        )}
      </Box>
      <br />
      <br />
    </>
  );
};
